import { useState } from "react";

// Captures the timestamp a form first rendered. Submissions faster
// than a human could plausibly read + fill the form (a few seconds)
// are a strong bot signal, independent of the honeypot check.
export function useFormTiming() {
  const [startedAt] = useState(() => Date.now());
  return startedAt;
}
